import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import { ThomasAlert } from './ThomasMessage';
import { ExitIcon } from '../Icons/EditIcons';
import { Link } from 'react-router-dom';

class ErrorPage extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }
  componentDidMount() {}

  render() {
    console.log('ErrorPage render');

    return (
      <section>
        <h1 className="page-title">Error!</h1>
        <section className="card">
          <ThomasAlert />
          <br />
          <Link to="/logout">
            <ExitIcon /> Logout
          </Link>
        </section>
      </section>
    );
  }
}

export default ErrorPage;
